module.exports = __webpack_public_path__ + "img/favorite-work.c2ff80ca.svg";